'use client';

import { useLayoutStore } from '@/hooks/use-layout-store';
import { ReactNode } from 'react';

type CustomChangeLayoutProps = {
    legacyComponent: ReactNode;
    modernComponent: ReactNode;
};

/**Render layout theo 2 version */
export function CustomChangeLayout({
    legacyComponent,
    modernComponent,
}: CustomChangeLayoutProps) {
    const layoutVersion = useLayoutStore((state) => state.version);
    if (layoutVersion === 'legacy') return legacyComponent;
    return modernComponent;
}
